<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="m-4 mx-1 mt-4">
      <h2 class="font-weight-bold">{{ $t("products") }}</h2>
      <div>
        <v-btn color="warning" class="mr-2" dark @click="addProduct">
          {{ $t("add_products") }}
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-btn color="warning" dark @click="addMulipleProduct">
          {{ $t("add_multiple_products") }}
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-btn color="warning" class="mx-2" dark @click="viewSheets">
          {{ $t("view_sheet") }}
        </v-btn>
      </div>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="barcode"
          :label="$t('search_by_barcode')"
          @input="handleInput"
          dense
          outlined
          :key="autoKey"
          ref="barcodeInput"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          :label="$t('filter_by_product_name')"
          outlined
          dense
          v-model="filter"
        />
      </v-col>
    </v-row>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="products"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        :footer-props="{ 'items-per-page-options': [10, 20, 50], 'items-per-page-text': $t('rows_per_page') }"
        class="elevation-1"
        @update:page="fetchProducts"
        @update:items-per-page="fetchProducts"
      >
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
            {{ $t("pagination", { start: pageStart, end: pageStop, total: itemsLength }) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a class="blue--text text--darken-2" href="#">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="editProduct(item)">
                <v-list-item-title>{{
                  $t("update_product")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteProduct(item)">
                <v-list-item-title>{{
                  $t("delete_product")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="viewDetail(item)">
                <v-list-item-title>{{
                  $t("view_product_details")
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <delete-modal v-model="deleteDialog" @confirm="confirmDelete" />
  </v-container>
</template>

<script>
import api from "../services/axios";
import DeleteModal from "../components/DeleteModal.vue";

export default {
  components: {
    DeleteModal,
  },
  data() {
    return {
      autoKey: 0,
      barcode: null,
      deleteDialog: false,
      selectedItem: null,
      filter: "",
      loading: false,
      totalItems: 0,
      products: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  watch: {
    "pagination.page": "fetchProducts",
    "pagination.itemsPerPage": "fetchProducts",
    "filter": "fetchProducts",
  },
  mounted() {
    this.fetchProducts();
    this.debouncedSearch = this.debounce(this.searchAction, 500);
  },
  computed: {
    headers() {
      return [
        { text: this.$t("id"), value: "id" },
        { text: this.$t("product_name"), value: "name" },
        { text: this.$t("number_of_boxes"), value: "total_boxes" },
        { text: this.$t("number_of_products"), value: "total_items" },
        { text: this.$t("purchased_price_per_product"), value: "purchase_price_per_item" },
        { text: this.$t("selling_price_per_product"), value: "selling_price_per_item" },
        { text: this.$t("total_purchase_price"), value: "total_purchase_price" },
        { text: this.$t("added_date"), value: "created_at" },
        // { text: this.$t("added_by"), value: "addedby" },
        { text: "", value: "actions", sortable: false, align: "right" },
      ];
    },
  },
  methods: {
    debounce(func, wait) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    },

    handleInput() {
      this.debouncedSearch();
    },

    async searchAction() {
      try {
        const res = await api.get(`/product/barcode?barcode=${this.barcode}`);
        if (res.data.status) {
          this.filter = res.data.data.name;
          this.barcode = null;
          this.autoKey++;
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
      }
    },
    async fetchProducts() {
      this.loading = true;
      try {
        const { page, itemsPerPage } = this.pagination;
        const res = await api.get("/product", {
          params: {
            page,
            perPage: itemsPerPage,
            filter: this.filter,
            sub_category_id: this.$route.query.id
          },
        });

        this.products = res.data.data.data.map((val) => ({
          ...val,
          addedby: val.addedby.name,
        })); // or res.data.products
        this.totalItems = res.data.data.total_records; // or res.data.meta.total
      } catch (error) {
        console.error("Failed to load products:", error);
      } finally {
        this.loading = false;
      }
    },

    addProduct() {
      this.$router.push("/dashboard/products/add");
    },
    addMulipleProduct() {
      this.$router.push("/dashboard/products/multiple");
    },
    viewSheets() {
      this.$router.push("/dashboard/products/sheets");
    },
    addDetail(item) {
      this.$router.push("/dashboard/products/" + item.id + "/details/add");
    },
    viewDetail(item) {
      this.$router.push("/dashboard/products/" + item.id + "/details/view");
    },
    editProduct(item) {
      this.$router.push("/dashboard/products/update/" + item.id);
    },
    deleteProduct(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },

    async confirmDelete() {
      try {
        const id = this.selectedItem.id;
        const res = await api.delete(`/product/delete/${id}`);
        if (!res.data.status) {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "error",
          });
        } else {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "success",
          });
          this.fetchProducts();
        }
      } catch (error) {
        this.$root.$emit("show-snackbar", {
          message: "Failed to delete Product",
          color: "error",
        });
        console.error("Delete failed:", error);
      }
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
</style>
